import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { useTheme } from 'hooks/theme';

import { Button, ButtonLink } from 'components/UI/Button';

import { PopupNotificationProps } from './type';

export const BonusesPopup: FC<PopupNotificationProps> = ({ closePopup }) => {
  const { t } = useTranslation('common');
  const { images } = useTheme();
  return (
    <>
      <div className="popup_image">
        <images.notificationBonuses.component />
      </div>
      <div className="popup_content">
        <h3>{t('notifications.bonuses.title')}</h3>
        <p>{t('notifications.bonuses.content')}</p>
        <div className="popup_ctrl">
          <ButtonLink href="/profile/bonus" onClick={closePopup}>
            {t('notifications.buttons.goTo')}
          </ButtonLink>
          <Button onClick={closePopup}>
            {t('notifications.buttons.informed')}
          </Button>
        </div>
      </div>
    </>
  );
};
